import { log } from 'console';
import { Address, Article } from './../types/index';
import axios, { AxiosError } from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { showLoginModal } from '../actions/ui';

import { API_URL } from '../config/env';
import {
  Business,
  User,
  Twig,
  Product,
  Category,
  City,
  DeliveryZone,
  Country,
} from '../types';
import {
  transformTwig,
  isTwig,
  isProduct,
  transformProduct,
  isBusiness,
  transformBusiness,
  transformUser,
  transformCategory,
  transformCity,
  transformDeliveryZone,
  transformAddress,
  transformCountry,
  existUserDeliverAddress,
  transformUserToken,
  transformArticle,
} from './helpers';
import { resolve } from 'path';

export async function getByUsername(
  username: string,
): Promise<{
  data: Twig | User | Business | Product|Article;
  type: 'twig' | 'product' | 'business' | 'user'|'article';
}> {
  const {
    data: {data,type},
  } = await axios.get(`${API_URL}/getByUsername?username=${username}`);
  if(type=="Article"){
    return {
      data: transformArticle(data),
      type: 'article',
    };
  }
  else if(type=="Twig") {
    return {
      data: transformTwig(data),
      type: 'twig',
    };
  } else if (type=="Product") {
    return {
      data: transformProduct(data),
      type: 'product',
    };
  } else if (type=="Business") {
    return {
      data: transformBusiness(data),
      type: 'business',
    };
  } else {
    return {
      data: transformUser(data),
      type: 'user',
    };
  }
}

export async function registerUser(form: any): Promise<{user: User;token: string;}> {

  return new Promise(async(resolve, reject) => {
    try{
      const {
        data: { data },
      } = await axios.post(`${API_URL}/users`, form);
      resolve({
        user: transformUser(data),
        token: data.token,
      });
    }
    catch(error){
      let message;
      const err = error as AxiosError;
      if (err.response && err.response.data.errors.mobile_number) {
        message=err.response.data.errors.mobile_number;
      }
      else if (err.response && err.response.data.errors.email){
        message=err.response.data.errors.email;
      }
      else{
        message="Something went wrong";
      }
        reject(message);
      }
  })
}

export async function loginUser(
  form: any,
): Promise<{
  user: User;
  token: string;
}> {
  const {
    data: { data },
  } = await axios.post(`${API_URL}/auth/login`, form);
  return {
    user: transformUser(data),
    token: data.token,
  };
}

export async function getAllCategories(): Promise<Category[]> {
  const {
    data: { data },
  } = await axios.get(`${API_URL}/categories/statistics?limit=100`);

  return data.map((category: any) => transformCategory(category));
}


export async function getAllIndustries(): Promise<Category[]> {
  const {
    data: { data },
  } = await axios.get(`${API_URL}/categories/industries?limit=100`);

  return data.map((category: any) => transformCategory(category));
}

export async function getAllCities(params: string = ""): Promise<City[]> {

  return new Promise(async(resolve, reject) => {
    try {
      const {
        data: { data },
      } = await axios.get(`${API_URL}/cities?all=true&is_delivery_supported=1&include_areas=true` + params);
      resolve(data.map((city: any) => transformCity(city)));
    }
     catch(error){
        reject(error);
      }
  })
}
export async function getAllCountries(params: string = ""): Promise<Country[]> {
  const {
    data: { data },
  } = await axios.get(`${API_URL}/countries?all=true&include_areas=true` + params);

  return data.map((city: any) => transformCountry(city));
}



export async function createBusiness(data: any) {
  return axios.post(`${API_URL}/businesses`, data);
}

export async function createCreater(data: any) {
  return axios.post(`${API_URL}/creators_program_request`, data);
}

export async function getBusinessDeliveryZones(
  id: string,
): Promise<DeliveryZone[]> {
  const {
    data: { data },
  } = await axios.get(`${API_URL}/delivery_zones?business_id=${id}`);
  return data.map(transformDeliveryZone);
}

export async function createAddress(form: any) :Promise<any>
 {
   
  return new Promise(async(resolve, reject) => {
    try {
        const {data :{data}} = await axios.post(`${API_URL}/User_delivery_locations`, form);
          if(data.user.is_guest && !data.user.is_exist_before){
            resolve({is_guest:true,data:transformUserToken(data.user),is_exist_before:false});
          }
          else if(data.user.is_guest  && data.user.is_exist_before && existUserDeliverAddress(data)){
            resolve({is_guest:true,data:transformAddress(data.user_deliver_address),existUserDeliverAddress:true,is_exist_before:true});
          }
          else if(data.user.is_guest  && data.user.is_exist_before && !existUserDeliverAddress(data)){
            resolve({is_guest:true,data:transformUserToken(data.user),existUserDeliverAddress:false,is_exist_before:true});
          }
          else{
            resolve({is_guest:data.user.is_guest,data:transformAddress(data.user_deliver_address)});
          }
    }
     catch(error){
        const err = error as AxiosError;
        if (err.response) {
          let message=err.response.data.error.message;
          if(message==="User Already Exists" && err.response.status===409)
            reject(message);
        }
    }
  })
};

export async function getArticlesById(params: string): Promise<Article[]> {
  return new Promise(async(resolve, reject) => {
    try{
      const {
        data: { data },
      } = await axios.get(`${API_URL}/articles?`+params);
      resolve(data.map((article: any) => transformArticle(article)));
    }
    catch(error){
      reject(error);
    }
  })
};

export async function submitOrder(order: any): Promise<any> {
  return new Promise(async(resolve, reject) => {
    try{
      const {
        data: { data, client_secret },
      } = await axios.post(`${API_URL}/checkout_orders`, order);
      resolve({"ids":data,client_secret});
    }
    catch(error){
      reject(error);
    } 
  })

  // const {
  //   data: { data, client_secret },
  // } = await axios.post(`${API_URL}/checkout_orders`, order);
  // return {"ids":data,client_secret};
}

export async function checkforVoucher(body: any): Promise<any> {
  const {
    data: { data },
  } = await axios.post(`${API_URL}/check_voucher`, body);
  return data;
}

export async function googleLogin(body: any): Promise<any> {
  const {
    data: { data },
  } = await axios.post(`${API_URL}/auth/login/google`, body);
  return data;
}

export async function facebookLogin(body: any): Promise<any> {
  const {
    data: { data },
  } = await axios.post(`${API_URL}/auth/login/facebook`, body);
  return data;
}

export async function continueProfile(body: any, token: string): Promise<any> {

  return new Promise(async(resolve, reject) => {
    try{
      const config = {
        headers: { "token": token }
      };
      const {
        data: { data },
      } = await axios.post(`${API_URL}/auth/profile`, body, config);
      resolve(data);
    }
    catch(error){
      let message;
      const err = error as AxiosError;
      if (err.response && err.response.data.errors.mobile_number) {
        message=err.response.data.errors.mobile_number;
      }
      else{
        message="Something went wrong";
      }
        reject(message);
      }
  })
 
}

